export const WindowWidth = {
  TABLET: 801,
  LAPTOP: 1024,
};

export const MIN_WINDOW_HEIGHT_FOR_VERTICAL_CALENDAR = 780;
